/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, ElementRef, OnDestroy, Renderer2} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {DatagridRenderOrganizer} from './render-organizer';
export class DatagridHeadRenderer implements OnDestroy {
/**
 * @param {?} el
 * @param {?} renderer
 * @param {?} organizer
 */
constructor(private el: ElementRef,
private renderer: Renderer2, organizer: DatagridRenderOrganizer) {
        this.subscription = organizer.scrollbarWidth.subscribe(width => this.accountForScrollbar(width));
    }
private subscription: Subscription;
/**
 * @return {?}
 */
ngOnDestroy() {
        this.subscription.unsubscribe();
    }
/**
 * @param {?} width
 * @return {?}
 */
private accountForScrollbar(width: number) {
        this.renderer.setStyle(this.el.nativeElement, "padding-right", width + "px");
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrDgHead]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: DatagridRenderOrganizer, },
];
}

function DatagridHeadRenderer_tsickle_Closure_declarations() {
/** @type {?} */
DatagridHeadRenderer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridHeadRenderer.ctorParameters;
/** @type {?} */
DatagridHeadRenderer.prototype.subscription;
/** @type {?} */
DatagridHeadRenderer.prototype.el;
/** @type {?} */
DatagridHeadRenderer.prototype.renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
